import {useCallback} from 'react';

import {DOCUMENT_LOCALE_FIELD_ID} from '@/constants/engine';
import {useConfig} from '@/contexts/config';
import {getLocaleCode} from '@/utils/locale';
import {DocumentStore} from '../../store/document-store';

export function useOnDocumentLocaleChange() {
  const {model} = useConfig();

  return useCallback(
    (changedKeys: string[], state: DocumentStore) => {
      if (changedKeys.includes(DOCUMENT_LOCALE_FIELD_ID)) {
        const nextValue = state.data[DOCUMENT_LOCALE_FIELD_ID];

        if (typeof nextValue !== 'object' || !('$ref' in nextValue)) {
          throw new Error('Locale value in the store should be a Reference object');
        }

        if (nextValue) {
          const nextLocale = getLocaleCode(nextValue, model);
          state.changeLocale(nextLocale);
        }
      }
    },
    [model],
  );
}
